const MapPage = () => {
    if (window.isMapPage === true) {
        setupMapPage();
    }
}

const setupMapPage = () => {

    const map = document.querySelector('.mapsvg');
    const back = document.querySelector('.map-page__controls');

    map.addEventListener('click', () => {

        let triggers = document.querySelectorAll('.enquiryModal-trigger');

        if (typeof triggers != "undefined" && triggers != null) {
            Array.prototype.forEach.call(triggers, (el) => {
                el.addEventListener('click', e => {
                    handleEnquiry(e.target);
                });
            });
        }

    });

    back.addEventListener('click', () => exitMapView());

}

// const handleEnquiry = (target) => {
//     const siblings = target.parentNode.childNodes;
//     const linkEl = [...siblings].filter(el => {
//         return el.tagName === 'A';
//     })[0];
//     let href = linkEl.href;

//     href = `${href}?enquiry=true`;

//     window.location = href;

// }

const handleEnquiry = (target) => {
    
    const urlParams = new URLSearchParams(window.location.search);
    const devID = urlParams.get('dev');

    let href;
    href = `/enquiry/?dev-id=${devID}`;

    window.location = href;

}

const exitMapView = () => {
    window.history.back();
}

export default MapPage;


// WEBPACK FOOTER //
// ./src/js/app/components/MapPage.js